module.exports = __webpack_public_path__ + "0f0fde58b6e75bf0bd7fa69d6173d9a0.MP3";